/* NOTE: AUTO GENERATED FILE! Do not modify directly! */

import * as React from 'react';
import { ReactComponent as AffiliateSmall } from '../../../assets/svg/icons/affiliate.small.svg';
import { ReactComponent as AffiliateMedium } from '../../../assets/svg/icons/affiliate.medium.svg';
import { ReactComponent as AffiliateLarge } from '../../../assets/svg/icons/affiliate.large.svg';
import { ReactComponent as AiAssistantSmall } from '../../../assets/svg/icons/aiAssistant.small.svg';
import { ReactComponent as AiAssistantMedium } from '../../../assets/svg/icons/aiAssistant.medium.svg';
import { ReactComponent as AiAssistantLarge } from '../../../assets/svg/icons/aiAssistant.large.svg';
import { ReactComponent as ArrowDownSmall } from '../../../assets/svg/icons/arrowDown.small.svg';
import { ReactComponent as ArrowDownMedium } from '../../../assets/svg/icons/arrowDown.medium.svg';
import { ReactComponent as ArrowDownLarge } from '../../../assets/svg/icons/arrowDown.large.svg';
import { ReactComponent as ArrowLeftSmall } from '../../../assets/svg/icons/arrowLeft.small.svg';
import { ReactComponent as ArrowLeftMedium } from '../../../assets/svg/icons/arrowLeft.medium.svg';
import { ReactComponent as ArrowLeftLarge } from '../../../assets/svg/icons/arrowLeft.large.svg';
import { ReactComponent as ArrowPNSmall } from '../../../assets/svg/icons/arrowPN.small.svg';
import { ReactComponent as ArrowPNMedium } from '../../../assets/svg/icons/arrowPN.medium.svg';
import { ReactComponent as ArrowPNLarge } from '../../../assets/svg/icons/arrowPN.large.svg';
import { ReactComponent as ArrowRightSmall } from '../../../assets/svg/icons/arrowRight.small.svg';
import { ReactComponent as ArrowRightMedium } from '../../../assets/svg/icons/arrowRight.medium.svg';
import { ReactComponent as ArrowRightLarge } from '../../../assets/svg/icons/arrowRight.large.svg';
import { ReactComponent as ArrowUpSmall } from '../../../assets/svg/icons/arrowUp.small.svg';
import { ReactComponent as ArrowUpMedium } from '../../../assets/svg/icons/arrowUp.medium.svg';
import { ReactComponent as ArrowUpLarge } from '../../../assets/svg/icons/arrowUp.large.svg';
import { ReactComponent as BellSmall } from '../../../assets/svg/icons/bell.small.svg';
import { ReactComponent as BellMedium } from '../../../assets/svg/icons/bell.medium.svg';
import { ReactComponent as BellLarge } from '../../../assets/svg/icons/bell.large.svg';
import { ReactComponent as BillingSmall } from '../../../assets/svg/icons/billing.small.svg';
import { ReactComponent as BillingMedium } from '../../../assets/svg/icons/billing.medium.svg';
import { ReactComponent as BillingLarge } from '../../../assets/svg/icons/billing.large.svg';
import { ReactComponent as BoostSmall } from '../../../assets/svg/icons/boost.small.svg';
import { ReactComponent as BoostMedium } from '../../../assets/svg/icons/boost.medium.svg';
import { ReactComponent as BoostLarge } from '../../../assets/svg/icons/boost.large.svg';
import { ReactComponent as BrowserSmall } from '../../../assets/svg/icons/browser.small.svg';
import { ReactComponent as BrowserMedium } from '../../../assets/svg/icons/browser.medium.svg';
import { ReactComponent as BrowserLarge } from '../../../assets/svg/icons/browser.large.svg';
import { ReactComponent as CallSmall } from '../../../assets/svg/icons/call.small.svg';
import { ReactComponent as CallMedium } from '../../../assets/svg/icons/call.medium.svg';
import { ReactComponent as CallLarge } from '../../../assets/svg/icons/call.large.svg';
import { ReactComponent as CanvaSmall } from '../../../assets/svg/icons/canva.small.svg';
import { ReactComponent as CanvaMedium } from '../../../assets/svg/icons/canva.medium.svg';
import { ReactComponent as CanvaLarge } from '../../../assets/svg/icons/canva.large.svg';
import { ReactComponent as CarouselSmall } from '../../../assets/svg/icons/carousel.small.svg';
import { ReactComponent as CarouselMedium } from '../../../assets/svg/icons/carousel.medium.svg';
import { ReactComponent as CarouselLarge } from '../../../assets/svg/icons/carousel.large.svg';
import { ReactComponent as ChartSmall } from '../../../assets/svg/icons/chart.small.svg';
import { ReactComponent as ChartMedium } from '../../../assets/svg/icons/chart.medium.svg';
import { ReactComponent as ChartLarge } from '../../../assets/svg/icons/chart.large.svg';
import { ReactComponent as ClicksSmall } from '../../../assets/svg/icons/clicks.small.svg';
import { ReactComponent as ClicksMedium } from '../../../assets/svg/icons/clicks.medium.svg';
import { ReactComponent as ClicksLarge } from '../../../assets/svg/icons/clicks.large.svg';
import { ReactComponent as ClipboardSmall } from '../../../assets/svg/icons/clipboard.small.svg';
import { ReactComponent as ClipboardMedium } from '../../../assets/svg/icons/clipboard.medium.svg';
import { ReactComponent as ClipboardLarge } from '../../../assets/svg/icons/clipboard.large.svg';
import { ReactComponent as CommentsSmall } from '../../../assets/svg/icons/comments.small.svg';
import { ReactComponent as CommentsMedium } from '../../../assets/svg/icons/comments.medium.svg';
import { ReactComponent as CommentsLarge } from '../../../assets/svg/icons/comments.large.svg';
import { ReactComponent as CrownSmall } from '../../../assets/svg/icons/crown.small.svg';
import { ReactComponent as CrownMedium } from '../../../assets/svg/icons/crown.medium.svg';
import { ReactComponent as CrownLarge } from '../../../assets/svg/icons/crown.large.svg';
import { ReactComponent as CycleLengthSmall } from '../../../assets/svg/icons/cycleLength.small.svg';
import { ReactComponent as CycleLengthMedium } from '../../../assets/svg/icons/cycleLength.medium.svg';
import { ReactComponent as CycleLengthLarge } from '../../../assets/svg/icons/cycleLength.large.svg';
import { ReactComponent as CyclesSmall } from '../../../assets/svg/icons/cycles.small.svg';
import { ReactComponent as CyclesMedium } from '../../../assets/svg/icons/cycles.medium.svg';
import { ReactComponent as CyclesLarge } from '../../../assets/svg/icons/cycles.large.svg';
import { ReactComponent as DebuggerSmall } from '../../../assets/svg/icons/debugger.small.svg';
import { ReactComponent as DebuggerMedium } from '../../../assets/svg/icons/debugger.medium.svg';
import { ReactComponent as DebuggerLarge } from '../../../assets/svg/icons/debugger.large.svg';
import { ReactComponent as DelaySmall } from '../../../assets/svg/icons/delay.small.svg';
import { ReactComponent as DelayMedium } from '../../../assets/svg/icons/delay.medium.svg';
import { ReactComponent as DelayLarge } from '../../../assets/svg/icons/delay.large.svg';
import { ReactComponent as DownloadSmall } from '../../../assets/svg/icons/download.small.svg';
import { ReactComponent as DownloadMedium } from '../../../assets/svg/icons/download.medium.svg';
import { ReactComponent as DownloadLarge } from '../../../assets/svg/icons/download.large.svg';
import { ReactComponent as DragHandleSmall } from '../../../assets/svg/icons/dragHandle.small.svg';
import { ReactComponent as DragHandleMedium } from '../../../assets/svg/icons/dragHandle.medium.svg';
import { ReactComponent as DragHandleLarge } from '../../../assets/svg/icons/dragHandle.large.svg';
import { ReactComponent as DuplicateSmall } from '../../../assets/svg/icons/duplicate.small.svg';
import { ReactComponent as DuplicateMedium } from '../../../assets/svg/icons/duplicate.medium.svg';
import { ReactComponent as DuplicateLarge } from '../../../assets/svg/icons/duplicate.large.svg';
import { ReactComponent as EditSmall } from '../../../assets/svg/icons/edit.small.svg';
import { ReactComponent as EditMedium } from '../../../assets/svg/icons/edit.medium.svg';
import { ReactComponent as EditLarge } from '../../../assets/svg/icons/edit.large.svg';
import { ReactComponent as EmojiSmall } from '../../../assets/svg/icons/emoji.small.svg';
import { ReactComponent as EmojiMedium } from '../../../assets/svg/icons/emoji.medium.svg';
import { ReactComponent as EmojiLarge } from '../../../assets/svg/icons/emoji.large.svg';
import { ReactComponent as ExclamationSmall } from '../../../assets/svg/icons/exclamation.small.svg';
import { ReactComponent as ExclamationMedium } from '../../../assets/svg/icons/exclamation.medium.svg';
import { ReactComponent as ExclamationLarge } from '../../../assets/svg/icons/exclamation.large.svg';
import { ReactComponent as FacebookSmall } from '../../../assets/svg/icons/facebook.small.svg';
import { ReactComponent as FacebookMedium } from '../../../assets/svg/icons/facebook.medium.svg';
import { ReactComponent as FacebookLarge } from '../../../assets/svg/icons/facebook.large.svg';
import { ReactComponent as FilterSmall } from '../../../assets/svg/icons/filter.small.svg';
import { ReactComponent as FilterMedium } from '../../../assets/svg/icons/filter.medium.svg';
import { ReactComponent as FilterLarge } from '../../../assets/svg/icons/filter.large.svg';
import { ReactComponent as FolderSmall } from '../../../assets/svg/icons/folder.small.svg';
import { ReactComponent as FolderMedium } from '../../../assets/svg/icons/folder.medium.svg';
import { ReactComponent as FolderLarge } from '../../../assets/svg/icons/folder.large.svg';
import { ReactComponent as GifBadgeSmall } from '../../../assets/svg/icons/gifBadge.small.svg';
import { ReactComponent as GifBadgeMedium } from '../../../assets/svg/icons/gifBadge.medium.svg';
import { ReactComponent as GifBadgeLarge } from '../../../assets/svg/icons/gifBadge.large.svg';
import { ReactComponent as GoogleSmall } from '../../../assets/svg/icons/google.small.svg';
import { ReactComponent as GoogleMedium } from '../../../assets/svg/icons/google.medium.svg';
import { ReactComponent as GoogleLarge } from '../../../assets/svg/icons/google.large.svg';
import { ReactComponent as GrabHandleSmall } from '../../../assets/svg/icons/grabHandle.small.svg';
import { ReactComponent as GrabHandleMedium } from '../../../assets/svg/icons/grabHandle.medium.svg';
import { ReactComponent as GrabHandleLarge } from '../../../assets/svg/icons/grabHandle.large.svg';
import { ReactComponent as HashtagSmall } from '../../../assets/svg/icons/hashtag.small.svg';
import { ReactComponent as HashtagMedium } from '../../../assets/svg/icons/hashtag.medium.svg';
import { ReactComponent as HashtagLarge } from '../../../assets/svg/icons/hashtag.large.svg';
import { ReactComponent as HelpSmall } from '../../../assets/svg/icons/help.small.svg';
import { ReactComponent as HelpMedium } from '../../../assets/svg/icons/help.medium.svg';
import { ReactComponent as HelpLarge } from '../../../assets/svg/icons/help.large.svg';
import { ReactComponent as IgSaveSmall } from '../../../assets/svg/icons/igSave.small.svg';
import { ReactComponent as IgSaveMedium } from '../../../assets/svg/icons/igSave.medium.svg';
import { ReactComponent as IgSaveLarge } from '../../../assets/svg/icons/igSave.large.svg';
import { ReactComponent as IgSendSmall } from '../../../assets/svg/icons/igSend.small.svg';
import { ReactComponent as IgSendMedium } from '../../../assets/svg/icons/igSend.medium.svg';
import { ReactComponent as IgSendLarge } from '../../../assets/svg/icons/igSend.large.svg';
import { ReactComponent as ImportSmall } from '../../../assets/svg/icons/import.small.svg';
import { ReactComponent as ImportMedium } from '../../../assets/svg/icons/import.medium.svg';
import { ReactComponent as ImportLarge } from '../../../assets/svg/icons/import.large.svg';
import { ReactComponent as ImpressionsSmall } from '../../../assets/svg/icons/impressions.small.svg';
import { ReactComponent as ImpressionsMedium } from '../../../assets/svg/icons/impressions.medium.svg';
import { ReactComponent as ImpressionsLarge } from '../../../assets/svg/icons/impressions.large.svg';
import { ReactComponent as InfoSmall } from '../../../assets/svg/icons/info.small.svg';
import { ReactComponent as InfoMedium } from '../../../assets/svg/icons/info.medium.svg';
import { ReactComponent as InfoLarge } from '../../../assets/svg/icons/info.large.svg';
import { ReactComponent as IterationSmall } from '../../../assets/svg/icons/iteration.small.svg';
import { ReactComponent as IterationMedium } from '../../../assets/svg/icons/iteration.medium.svg';
import { ReactComponent as IterationLarge } from '../../../assets/svg/icons/iteration.large.svg';
import { ReactComponent as LikesSmall } from '../../../assets/svg/icons/likes.small.svg';
import { ReactComponent as LikesMedium } from '../../../assets/svg/icons/likes.medium.svg';
import { ReactComponent as LikesLarge } from '../../../assets/svg/icons/likes.large.svg';
import { ReactComponent as LinkSmall } from '../../../assets/svg/icons/link.small.svg';
import { ReactComponent as LinkMedium } from '../../../assets/svg/icons/link.medium.svg';
import { ReactComponent as LinkLarge } from '../../../assets/svg/icons/link.large.svg';
import { ReactComponent as LogoutSmall } from '../../../assets/svg/icons/logout.small.svg';
import { ReactComponent as LogoutMedium } from '../../../assets/svg/icons/logout.medium.svg';
import { ReactComponent as LogoutLarge } from '../../../assets/svg/icons/logout.large.svg';
import { ReactComponent as MailSmall } from '../../../assets/svg/icons/mail.small.svg';
import { ReactComponent as MailMedium } from '../../../assets/svg/icons/mail.medium.svg';
import { ReactComponent as MailLarge } from '../../../assets/svg/icons/mail.large.svg';
import { ReactComponent as MobileSmall } from '../../../assets/svg/icons/mobile.small.svg';
import { ReactComponent as MobileMedium } from '../../../assets/svg/icons/mobile.medium.svg';
import { ReactComponent as MobileLarge } from '../../../assets/svg/icons/mobile.large.svg';
import { ReactComponent as MoveUpSmall } from '../../../assets/svg/icons/moveUp.small.svg';
import { ReactComponent as MoveUpMedium } from '../../../assets/svg/icons/moveUp.medium.svg';
import { ReactComponent as MoveUpLarge } from '../../../assets/svg/icons/moveUp.large.svg';
import { ReactComponent as MultidateSmall } from '../../../assets/svg/icons/multidate.small.svg';
import { ReactComponent as MultidateMedium } from '../../../assets/svg/icons/multidate.medium.svg';
import { ReactComponent as MultidateLarge } from '../../../assets/svg/icons/multidate.large.svg';
import { ReactComponent as NoDataSmall } from '../../../assets/svg/icons/noData.small.svg';
import { ReactComponent as NoDataMedium } from '../../../assets/svg/icons/noData.medium.svg';
import { ReactComponent as NoDataLarge } from '../../../assets/svg/icons/noData.large.svg';
import { ReactComponent as PauseSmall } from '../../../assets/svg/icons/pause.small.svg';
import { ReactComponent as PauseMedium } from '../../../assets/svg/icons/pause.medium.svg';
import { ReactComponent as PauseLarge } from '../../../assets/svg/icons/pause.large.svg';
import { ReactComponent as PhotoSmall } from '../../../assets/svg/icons/photo.small.svg';
import { ReactComponent as PhotoMedium } from '../../../assets/svg/icons/photo.medium.svg';
import { ReactComponent as PhotoLarge } from '../../../assets/svg/icons/photo.large.svg';
import { ReactComponent as PinSmall } from '../../../assets/svg/icons/pin.small.svg';
import { ReactComponent as PinMedium } from '../../../assets/svg/icons/pin.medium.svg';
import { ReactComponent as PinLarge } from '../../../assets/svg/icons/pin.large.svg';
import { ReactComponent as PlaySmall } from '../../../assets/svg/icons/play.small.svg';
import { ReactComponent as PlayMedium } from '../../../assets/svg/icons/play.medium.svg';
import { ReactComponent as PlayLarge } from '../../../assets/svg/icons/play.large.svg';
import { ReactComponent as PlusSmall } from '../../../assets/svg/icons/plus.small.svg';
import { ReactComponent as PlusMedium } from '../../../assets/svg/icons/plus.medium.svg';
import { ReactComponent as PlusLarge } from '../../../assets/svg/icons/plus.large.svg';
import { ReactComponent as PreferencesSmall } from '../../../assets/svg/icons/preferences.small.svg';
import { ReactComponent as PreferencesMedium } from '../../../assets/svg/icons/preferences.medium.svg';
import { ReactComponent as PreferencesLarge } from '../../../assets/svg/icons/preferences.large.svg';
import { ReactComponent as QueuedSmall } from '../../../assets/svg/icons/queued.small.svg';
import { ReactComponent as QueuedMedium } from '../../../assets/svg/icons/queued.medium.svg';
import { ReactComponent as QueuedLarge } from '../../../assets/svg/icons/queued.large.svg';
import { ReactComponent as ReGenerateSmall } from '../../../assets/svg/icons/reGenerate.small.svg';
import { ReactComponent as ReGenerateMedium } from '../../../assets/svg/icons/reGenerate.medium.svg';
import { ReactComponent as ReGenerateLarge } from '../../../assets/svg/icons/reGenerate.large.svg';
import { ReactComponent as RetweetsSmall } from '../../../assets/svg/icons/retweets.small.svg';
import { ReactComponent as RetweetsMedium } from '../../../assets/svg/icons/retweets.medium.svg';
import { ReactComponent as RetweetsLarge } from '../../../assets/svg/icons/retweets.large.svg';
import { ReactComponent as SearchSmall } from '../../../assets/svg/icons/search.small.svg';
import { ReactComponent as SearchMedium } from '../../../assets/svg/icons/search.medium.svg';
import { ReactComponent as SearchLarge } from '../../../assets/svg/icons/search.large.svg';
import { ReactComponent as SettingsSmall } from '../../../assets/svg/icons/settings.small.svg';
import { ReactComponent as SettingsMedium } from '../../../assets/svg/icons/settings.medium.svg';
import { ReactComponent as SettingsLarge } from '../../../assets/svg/icons/settings.large.svg';
import { ReactComponent as ShareSmall } from '../../../assets/svg/icons/share.small.svg';
import { ReactComponent as ShareMedium } from '../../../assets/svg/icons/share.medium.svg';
import { ReactComponent as ShareLarge } from '../../../assets/svg/icons/share.large.svg';
import { ReactComponent as SnippetSmall } from '../../../assets/svg/icons/snippet.small.svg';
import { ReactComponent as SnippetMedium } from '../../../assets/svg/icons/snippet.medium.svg';
import { ReactComponent as SnippetLarge } from '../../../assets/svg/icons/snippet.large.svg';
import { ReactComponent as SubscriptionSmall } from '../../../assets/svg/icons/subscription.small.svg';
import { ReactComponent as SubscriptionMedium } from '../../../assets/svg/icons/subscription.medium.svg';
import { ReactComponent as SubscriptionLarge } from '../../../assets/svg/icons/subscription.large.svg';
import { ReactComponent as TargetSmall } from '../../../assets/svg/icons/target.small.svg';
import { ReactComponent as TargetMedium } from '../../../assets/svg/icons/target.medium.svg';
import { ReactComponent as TargetLarge } from '../../../assets/svg/icons/target.large.svg';
import { ReactComponent as TeamSmall } from '../../../assets/svg/icons/team.small.svg';
import { ReactComponent as TeamMedium } from '../../../assets/svg/icons/team.medium.svg';
import { ReactComponent as TeamLarge } from '../../../assets/svg/icons/team.large.svg';
import { ReactComponent as ThreadsSmall } from '../../../assets/svg/icons/threads.small.svg';
import { ReactComponent as ThreadsMedium } from '../../../assets/svg/icons/threads.medium.svg';
import { ReactComponent as ThreadsLarge } from '../../../assets/svg/icons/threads.large.svg';
import { ReactComponent as ThreeDotSmall } from '../../../assets/svg/icons/threeDot.small.svg';
import { ReactComponent as ThreeDotMedium } from '../../../assets/svg/icons/threeDot.medium.svg';
import { ReactComponent as ThreeDotLarge } from '../../../assets/svg/icons/threeDot.large.svg';
import { ReactComponent as ThumbUpSmall } from '../../../assets/svg/icons/thumbUp.small.svg';
import { ReactComponent as ThumbUpMedium } from '../../../assets/svg/icons/thumbUp.medium.svg';
import { ReactComponent as ThumbUpLarge } from '../../../assets/svg/icons/thumbUp.large.svg';
import { ReactComponent as TickSmall } from '../../../assets/svg/icons/tick.small.svg';
import { ReactComponent as TickMedium } from '../../../assets/svg/icons/tick.medium.svg';
import { ReactComponent as TickLarge } from '../../../assets/svg/icons/tick.large.svg';
import { ReactComponent as TrashSmall } from '../../../assets/svg/icons/trash.small.svg';
import { ReactComponent as TrashMedium } from '../../../assets/svg/icons/trash.medium.svg';
import { ReactComponent as TrashLarge } from '../../../assets/svg/icons/trash.large.svg';
import { ReactComponent as TriangleDownSmall } from '../../../assets/svg/icons/triangleDown.small.svg';
import { ReactComponent as TriangleDownMedium } from '../../../assets/svg/icons/triangleDown.medium.svg';
import { ReactComponent as TriangleDownLarge } from '../../../assets/svg/icons/triangleDown.large.svg';
import { ReactComponent as TriangleWarningSmall } from '../../../assets/svg/icons/triangleWarning.small.svg';
import { ReactComponent as TriangleWarningMedium } from '../../../assets/svg/icons/triangleWarning.medium.svg';
import { ReactComponent as TriangleWarningLarge } from '../../../assets/svg/icons/triangleWarning.large.svg';
import { ReactComponent as UploadSmall } from '../../../assets/svg/icons/upload.small.svg';
import { ReactComponent as UploadMedium } from '../../../assets/svg/icons/upload.medium.svg';
import { ReactComponent as UploadLarge } from '../../../assets/svg/icons/upload.large.svg';
import { ReactComponent as UserProfileSmall } from '../../../assets/svg/icons/userProfile.small.svg';
import { ReactComponent as UserProfileMedium } from '../../../assets/svg/icons/userProfile.medium.svg';
import { ReactComponent as UserProfileLarge } from '../../../assets/svg/icons/userProfile.large.svg';
import { ReactComponent as VariationSmall } from '../../../assets/svg/icons/variation.small.svg';
import { ReactComponent as VariationMedium } from '../../../assets/svg/icons/variation.medium.svg';
import { ReactComponent as VariationLarge } from '../../../assets/svg/icons/variation.large.svg';
import { ReactComponent as VideoSmall } from '../../../assets/svg/icons/video.small.svg';
import { ReactComponent as VideoMedium } from '../../../assets/svg/icons/video.medium.svg';
import { ReactComponent as VideoLarge } from '../../../assets/svg/icons/video.large.svg';
import { ReactComponent as VideoViewsSmall } from '../../../assets/svg/icons/videoViews.small.svg';
import { ReactComponent as VideoViewsMedium } from '../../../assets/svg/icons/videoViews.medium.svg';
import { ReactComponent as VideoViewsLarge } from '../../../assets/svg/icons/videoViews.large.svg';
import { ReactComponent as WhatsNewSmall } from '../../../assets/svg/icons/whatsNew.small.svg';
import { ReactComponent as WhatsNewMedium } from '../../../assets/svg/icons/whatsNew.medium.svg';
import { ReactComponent as WhatsNewLarge } from '../../../assets/svg/icons/whatsNew.large.svg';
import { ReactComponent as YoutubeSmall } from '../../../assets/svg/icons/youtube.small.svg';
import { ReactComponent as YoutubeMedium } from '../../../assets/svg/icons/youtube.medium.svg';
import { ReactComponent as YoutubeLarge } from '../../../assets/svg/icons/youtube.large.svg';
import { IconsEnum } from '../../../constants/icons';

export type IconPropsType = {
  name: IconsEnum;
  size: 'small' | 'medium' | 'large';
};

export const Icon = (props: IconPropsType): JSX.Element => {
  switch (props.name) {
    case IconsEnum['affiliate']: {
      switch (props.size) {
        case 'small':
          return <AffiliateSmall />;
        case 'medium':
          return <AffiliateMedium />;
        case 'large':
          return <AffiliateLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['aiAssistant']: {
      switch (props.size) {
        case 'small':
          return <AiAssistantSmall />;
        case 'medium':
          return <AiAssistantMedium />;
        case 'large':
          return <AiAssistantLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['arrowDown']: {
      switch (props.size) {
        case 'small':
          return <ArrowDownSmall />;
        case 'medium':
          return <ArrowDownMedium />;
        case 'large':
          return <ArrowDownLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['arrowLeft']: {
      switch (props.size) {
        case 'small':
          return <ArrowLeftSmall />;
        case 'medium':
          return <ArrowLeftMedium />;
        case 'large':
          return <ArrowLeftLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['arrowPN']: {
      switch (props.size) {
        case 'small':
          return <ArrowPNSmall />;
        case 'medium':
          return <ArrowPNMedium />;
        case 'large':
          return <ArrowPNLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['arrowRight']: {
      switch (props.size) {
        case 'small':
          return <ArrowRightSmall />;
        case 'medium':
          return <ArrowRightMedium />;
        case 'large':
          return <ArrowRightLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['arrowUp']: {
      switch (props.size) {
        case 'small':
          return <ArrowUpSmall />;
        case 'medium':
          return <ArrowUpMedium />;
        case 'large':
          return <ArrowUpLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['bell']: {
      switch (props.size) {
        case 'small':
          return <BellSmall />;
        case 'medium':
          return <BellMedium />;
        case 'large':
          return <BellLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['billing']: {
      switch (props.size) {
        case 'small':
          return <BillingSmall />;
        case 'medium':
          return <BillingMedium />;
        case 'large':
          return <BillingLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['boost']: {
      switch (props.size) {
        case 'small':
          return <BoostSmall />;
        case 'medium':
          return <BoostMedium />;
        case 'large':
          return <BoostLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['browser']: {
      switch (props.size) {
        case 'small':
          return <BrowserSmall />;
        case 'medium':
          return <BrowserMedium />;
        case 'large':
          return <BrowserLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['call']: {
      switch (props.size) {
        case 'small':
          return <CallSmall />;
        case 'medium':
          return <CallMedium />;
        case 'large':
          return <CallLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['canva']: {
      switch (props.size) {
        case 'small':
          return <CanvaSmall />;
        case 'medium':
          return <CanvaMedium />;
        case 'large':
          return <CanvaLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['carousel']: {
      switch (props.size) {
        case 'small':
          return <CarouselSmall />;
        case 'medium':
          return <CarouselMedium />;
        case 'large':
          return <CarouselLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['chart']: {
      switch (props.size) {
        case 'small':
          return <ChartSmall />;
        case 'medium':
          return <ChartMedium />;
        case 'large':
          return <ChartLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['clicks']: {
      switch (props.size) {
        case 'small':
          return <ClicksSmall />;
        case 'medium':
          return <ClicksMedium />;
        case 'large':
          return <ClicksLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['clipboard']: {
      switch (props.size) {
        case 'small':
          return <ClipboardSmall />;
        case 'medium':
          return <ClipboardMedium />;
        case 'large':
          return <ClipboardLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['comments']: {
      switch (props.size) {
        case 'small':
          return <CommentsSmall />;
        case 'medium':
          return <CommentsMedium />;
        case 'large':
          return <CommentsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['crown']: {
      switch (props.size) {
        case 'small':
          return <CrownSmall />;
        case 'medium':
          return <CrownMedium />;
        case 'large':
          return <CrownLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['cycleLength']: {
      switch (props.size) {
        case 'small':
          return <CycleLengthSmall />;
        case 'medium':
          return <CycleLengthMedium />;
        case 'large':
          return <CycleLengthLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['cycles']: {
      switch (props.size) {
        case 'small':
          return <CyclesSmall />;
        case 'medium':
          return <CyclesMedium />;
        case 'large':
          return <CyclesLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['debugger']: {
      switch (props.size) {
        case 'small':
          return <DebuggerSmall />;
        case 'medium':
          return <DebuggerMedium />;
        case 'large':
          return <DebuggerLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['delay']: {
      switch (props.size) {
        case 'small':
          return <DelaySmall />;
        case 'medium':
          return <DelayMedium />;
        case 'large':
          return <DelayLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['download']: {
      switch (props.size) {
        case 'small':
          return <DownloadSmall />;
        case 'medium':
          return <DownloadMedium />;
        case 'large':
          return <DownloadLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['dragHandle']: {
      switch (props.size) {
        case 'small':
          return <DragHandleSmall />;
        case 'medium':
          return <DragHandleMedium />;
        case 'large':
          return <DragHandleLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['duplicate']: {
      switch (props.size) {
        case 'small':
          return <DuplicateSmall />;
        case 'medium':
          return <DuplicateMedium />;
        case 'large':
          return <DuplicateLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['edit']: {
      switch (props.size) {
        case 'small':
          return <EditSmall />;
        case 'medium':
          return <EditMedium />;
        case 'large':
          return <EditLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['emoji']: {
      switch (props.size) {
        case 'small':
          return <EmojiSmall />;
        case 'medium':
          return <EmojiMedium />;
        case 'large':
          return <EmojiLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['exclamation']: {
      switch (props.size) {
        case 'small':
          return <ExclamationSmall />;
        case 'medium':
          return <ExclamationMedium />;
        case 'large':
          return <ExclamationLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['facebook']: {
      switch (props.size) {
        case 'small':
          return <FacebookSmall />;
        case 'medium':
          return <FacebookMedium />;
        case 'large':
          return <FacebookLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['filter']: {
      switch (props.size) {
        case 'small':
          return <FilterSmall />;
        case 'medium':
          return <FilterMedium />;
        case 'large':
          return <FilterLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['folder']: {
      switch (props.size) {
        case 'small':
          return <FolderSmall />;
        case 'medium':
          return <FolderMedium />;
        case 'large':
          return <FolderLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['gifBadge']: {
      switch (props.size) {
        case 'small':
          return <GifBadgeSmall />;
        case 'medium':
          return <GifBadgeMedium />;
        case 'large':
          return <GifBadgeLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['google']: {
      switch (props.size) {
        case 'small':
          return <GoogleSmall />;
        case 'medium':
          return <GoogleMedium />;
        case 'large':
          return <GoogleLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['grabHandle']: {
      switch (props.size) {
        case 'small':
          return <GrabHandleSmall />;
        case 'medium':
          return <GrabHandleMedium />;
        case 'large':
          return <GrabHandleLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['hashtag']: {
      switch (props.size) {
        case 'small':
          return <HashtagSmall />;
        case 'medium':
          return <HashtagMedium />;
        case 'large':
          return <HashtagLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['help']: {
      switch (props.size) {
        case 'small':
          return <HelpSmall />;
        case 'medium':
          return <HelpMedium />;
        case 'large':
          return <HelpLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['igSave']: {
      switch (props.size) {
        case 'small':
          return <IgSaveSmall />;
        case 'medium':
          return <IgSaveMedium />;
        case 'large':
          return <IgSaveLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['igSend']: {
      switch (props.size) {
        case 'small':
          return <IgSendSmall />;
        case 'medium':
          return <IgSendMedium />;
        case 'large':
          return <IgSendLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['import']: {
      switch (props.size) {
        case 'small':
          return <ImportSmall />;
        case 'medium':
          return <ImportMedium />;
        case 'large':
          return <ImportLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['impressions']: {
      switch (props.size) {
        case 'small':
          return <ImpressionsSmall />;
        case 'medium':
          return <ImpressionsMedium />;
        case 'large':
          return <ImpressionsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['info']: {
      switch (props.size) {
        case 'small':
          return <InfoSmall />;
        case 'medium':
          return <InfoMedium />;
        case 'large':
          return <InfoLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['iteration']: {
      switch (props.size) {
        case 'small':
          return <IterationSmall />;
        case 'medium':
          return <IterationMedium />;
        case 'large':
          return <IterationLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['likes']: {
      switch (props.size) {
        case 'small':
          return <LikesSmall />;
        case 'medium':
          return <LikesMedium />;
        case 'large':
          return <LikesLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['link']: {
      switch (props.size) {
        case 'small':
          return <LinkSmall />;
        case 'medium':
          return <LinkMedium />;
        case 'large':
          return <LinkLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['logout']: {
      switch (props.size) {
        case 'small':
          return <LogoutSmall />;
        case 'medium':
          return <LogoutMedium />;
        case 'large':
          return <LogoutLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['mail']: {
      switch (props.size) {
        case 'small':
          return <MailSmall />;
        case 'medium':
          return <MailMedium />;
        case 'large':
          return <MailLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['mobile']: {
      switch (props.size) {
        case 'small':
          return <MobileSmall />;
        case 'medium':
          return <MobileMedium />;
        case 'large':
          return <MobileLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['moveUp']: {
      switch (props.size) {
        case 'small':
          return <MoveUpSmall />;
        case 'medium':
          return <MoveUpMedium />;
        case 'large':
          return <MoveUpLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['multidate']: {
      switch (props.size) {
        case 'small':
          return <MultidateSmall />;
        case 'medium':
          return <MultidateMedium />;
        case 'large':
          return <MultidateLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['noData']: {
      switch (props.size) {
        case 'small':
          return <NoDataSmall />;
        case 'medium':
          return <NoDataMedium />;
        case 'large':
          return <NoDataLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['pause']: {
      switch (props.size) {
        case 'small':
          return <PauseSmall />;
        case 'medium':
          return <PauseMedium />;
        case 'large':
          return <PauseLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['photo']: {
      switch (props.size) {
        case 'small':
          return <PhotoSmall />;
        case 'medium':
          return <PhotoMedium />;
        case 'large':
          return <PhotoLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['pin']: {
      switch (props.size) {
        case 'small':
          return <PinSmall />;
        case 'medium':
          return <PinMedium />;
        case 'large':
          return <PinLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['play']: {
      switch (props.size) {
        case 'small':
          return <PlaySmall />;
        case 'medium':
          return <PlayMedium />;
        case 'large':
          return <PlayLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['plus']: {
      switch (props.size) {
        case 'small':
          return <PlusSmall />;
        case 'medium':
          return <PlusMedium />;
        case 'large':
          return <PlusLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['preferences']: {
      switch (props.size) {
        case 'small':
          return <PreferencesSmall />;
        case 'medium':
          return <PreferencesMedium />;
        case 'large':
          return <PreferencesLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['queued']: {
      switch (props.size) {
        case 'small':
          return <QueuedSmall />;
        case 'medium':
          return <QueuedMedium />;
        case 'large':
          return <QueuedLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['reGenerate']: {
      switch (props.size) {
        case 'small':
          return <ReGenerateSmall />;
        case 'medium':
          return <ReGenerateMedium />;
        case 'large':
          return <ReGenerateLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['retweets']: {
      switch (props.size) {
        case 'small':
          return <RetweetsSmall />;
        case 'medium':
          return <RetweetsMedium />;
        case 'large':
          return <RetweetsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['search']: {
      switch (props.size) {
        case 'small':
          return <SearchSmall />;
        case 'medium':
          return <SearchMedium />;
        case 'large':
          return <SearchLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['settings']: {
      switch (props.size) {
        case 'small':
          return <SettingsSmall />;
        case 'medium':
          return <SettingsMedium />;
        case 'large':
          return <SettingsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['share']: {
      switch (props.size) {
        case 'small':
          return <ShareSmall />;
        case 'medium':
          return <ShareMedium />;
        case 'large':
          return <ShareLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['snippet']: {
      switch (props.size) {
        case 'small':
          return <SnippetSmall />;
        case 'medium':
          return <SnippetMedium />;
        case 'large':
          return <SnippetLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['subscription']: {
      switch (props.size) {
        case 'small':
          return <SubscriptionSmall />;
        case 'medium':
          return <SubscriptionMedium />;
        case 'large':
          return <SubscriptionLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['target']: {
      switch (props.size) {
        case 'small':
          return <TargetSmall />;
        case 'medium':
          return <TargetMedium />;
        case 'large':
          return <TargetLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['team']: {
      switch (props.size) {
        case 'small':
          return <TeamSmall />;
        case 'medium':
          return <TeamMedium />;
        case 'large':
          return <TeamLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['threads']: {
      switch (props.size) {
        case 'small':
          return <ThreadsSmall />;
        case 'medium':
          return <ThreadsMedium />;
        case 'large':
          return <ThreadsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['threeDot']: {
      switch (props.size) {
        case 'small':
          return <ThreeDotSmall />;
        case 'medium':
          return <ThreeDotMedium />;
        case 'large':
          return <ThreeDotLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['thumbUp']: {
      switch (props.size) {
        case 'small':
          return <ThumbUpSmall />;
        case 'medium':
          return <ThumbUpMedium />;
        case 'large':
          return <ThumbUpLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['tick']: {
      switch (props.size) {
        case 'small':
          return <TickSmall />;
        case 'medium':
          return <TickMedium />;
        case 'large':
          return <TickLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['trash']: {
      switch (props.size) {
        case 'small':
          return <TrashSmall />;
        case 'medium':
          return <TrashMedium />;
        case 'large':
          return <TrashLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['triangleDown']: {
      switch (props.size) {
        case 'small':
          return <TriangleDownSmall />;
        case 'medium':
          return <TriangleDownMedium />;
        case 'large':
          return <TriangleDownLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['triangleWarning']: {
      switch (props.size) {
        case 'small':
          return <TriangleWarningSmall />;
        case 'medium':
          return <TriangleWarningMedium />;
        case 'large':
          return <TriangleWarningLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['upload']: {
      switch (props.size) {
        case 'small':
          return <UploadSmall />;
        case 'medium':
          return <UploadMedium />;
        case 'large':
          return <UploadLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['userProfile']: {
      switch (props.size) {
        case 'small':
          return <UserProfileSmall />;
        case 'medium':
          return <UserProfileMedium />;
        case 'large':
          return <UserProfileLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['variation']: {
      switch (props.size) {
        case 'small':
          return <VariationSmall />;
        case 'medium':
          return <VariationMedium />;
        case 'large':
          return <VariationLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['video']: {
      switch (props.size) {
        case 'small':
          return <VideoSmall />;
        case 'medium':
          return <VideoMedium />;
        case 'large':
          return <VideoLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['videoViews']: {
      switch (props.size) {
        case 'small':
          return <VideoViewsSmall />;
        case 'medium':
          return <VideoViewsMedium />;
        case 'large':
          return <VideoViewsLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['whatsNew']: {
      switch (props.size) {
        case 'small':
          return <WhatsNewSmall />;
        case 'medium':
          return <WhatsNewMedium />;
        case 'large':
          return <WhatsNewLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    case IconsEnum['youtube']: {
      switch (props.size) {
        case 'small':
          return <YoutubeSmall />;
        case 'medium':
          return <YoutubeMedium />;
        case 'large':
          return <YoutubeLarge />;
        default:
          return <span>No Content for {props.size}!</span>;
      }
    }
    default:
      return <span>No Content!</span>;
  }
};
